/* eslint-disable no-nested-ternary */
import React from 'react';
import { makeStyles } from '@mui/styles';
import {
  Grid,
  Typography,
  SelectProps,
  FormControl,
  Select,
  MenuItem,
} from '@quillbot/design-system';
import { KeyboardArrowDown } from '@mui/icons-material';
import { getCgBreakpointDown } from 'src/citation-generator/utils';
import { CitationSourceEnum } from 'src/citation-generator/types';
import { citationSourceLabels } from 'src/citation-generator/constants/common.constants';
import { useEditFormDispatch, useEditFormState } from '../context';
import { setSourceType } from '../actionCreators';

const useSelectStyles = makeStyles((theme) => ({
  label: {
    float: 'right',
    fontSize: '12px',
    color: theme.palette.text.primary,
  },
  labelContainer: {
    width: '24%',
    paddingRight: '8px',
  },
  formControl: {
    border: '1px solid #E8E8E8',
    boxSizing: 'border-box',
    borderRadius: 4,
    flexGrow: 1,
    width: '170px',
    backgroundColor: '#E0E0E0',
    position: 'relative',
    [getCgBreakpointDown(theme)]: {
      width: '100%',
    },
  },
  select: {
    width: '100%',
    padding: '3px 5px 3px 9px',
    fontSize: '14px',
    fontWeight: 600,
    flexGrow: 1,
    color: '#000',
    border: 'none',
    borderBottom: 0,
    '&:hover': {
      border: 'none',
      color: '#000',
    },
    '&:focus': {
      color: '#000',
      border: 'none',
      backgroundColor: 'unset',
      borderRadius: 0,
      background: 'white',
    },
  },
  icon: {
    right: 12,
    position: 'absolute',
    userSelect: 'none',
    pointerEvents: 'none',
  },
  listPaper: {
    boxShadow: theme.shadows[4],
  },
  list: {
    backgroundColor: theme.palette.background.paper,
    '& li.Mui-selected': {
      backgroundColor: theme.palette.background.paper,
      fontWeight: 700,
      fontSize: '14px',
    },
    '& li': {
      fontSize: '14px',
    },
  },
}));

export function SourceTypeDropDown() {
  const classes = useSelectStyles();
  const value = useEditFormState((state) => state.sourceType);
  const dispatch = useEditFormDispatch();

  const menuProps: SelectProps['MenuProps'] = {
    style: {
      marginTop: 10,
    },
    classes: {
      list: classes.list,
      paper: classes.listPaper,
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
  };

  return (
    <Grid container alignItems="center" style={{ marginBottom: '10px' }}>
      <Grid item className={classes.labelContainer} alignItems="center">
        <Typography className={classes.label}>Type</Typography>
      </Grid>

      <Grid
        item
        style={{
          width: '76%',
        }}
      >
        <FormControl className={classes.formControl}>
          <Select
            disableUnderline
            value={value}
            variant="standard"
            onChange={(e) => {
              dispatch(setSourceType(e.target.value as CitationSourceEnum));
              // TODO: change/empty other field values here
            }}
            classes={{ select: classes.select }}
            IconComponent={(iconProps) => (
              <KeyboardArrowDown
                className={`${iconProps.className} ${classes.icon}`}
                style={{ color: '#000' }}
              />
            )}
            MenuProps={menuProps}
          >
            {Object.values(CitationSourceEnum).map((type) => (
              <MenuItem
                value={type}
                key={type}
                disabled={type === value}
                style={{
                  backgroundColor: type === value ? '#f1f1f1' : undefined,
                }}
              >
                {citationSourceLabels[type].label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
